import { AppStatusCanoticCrowd } from "./AppStatusCanoticCrowd"
import {
    AppStatusPrivateLabeling,
    getAppStatusPrivateLabeling
} from "./AppStatusPrivateLabeling"
import { APIAppInstanceState } from "../../Reducers/API/AppInstance/AppInstanceReducer"
import { APIAppTemplateModel } from "../API/AppTemplateModel"
import { AppStatusGeneral } from "./AppStatusGeneral"
import { hasValidAppParams } from "../API/AppInstanceModel"

export type AppStatus =
    | AppStatusCanoticCrowd
    | AppStatusPrivateLabeling
    | AppStatusGeneral

export function compareAppStatus(one: AppStatus, another: AppStatus): number {
    const priority: AppStatus[] = [
        /* lowest priority */
        AppStatusCanoticCrowd.jobSubmitRequired,
        AppStatusCanoticCrowd.reviewRequired,
        AppStatusCanoticCrowd.configureMetricsRequired,
        AppStatusCanoticCrowd.acceptCalibrationJobsRequired,
        AppStatusCanoticCrowd.paymentMethodMissing,
        AppStatusCanoticCrowd.labelingSuspended,
        AppStatusCanoticCrowd.calculatingMetrics,
        AppStatusCanoticCrowd.labeling,
        AppStatusPrivateLabeling.inviteSuggested,
        AppStatusPrivateLabeling.uploadSuggested,
        AppStatusGeneral.paramsSchemaMismatch
        /* highest priority */
    ]

    return priority.indexOf(one) - priority.indexOf(another)
}

export function getAppStatus(
    instance: APIAppInstanceState,
    template: APIAppTemplateModel,
    __: boolean
): AppStatus | undefined {
    if (!hasValidAppParams(instance, template)) {
        return AppStatusGeneral.paramsSchemaMismatch
    }

    if (instance.canoticCrowd) {
        return undefined
    }

    return getAppStatusPrivateLabeling(instance)
}
